export function getByPath(obj, path) {
  if (!obj) return undefined;
  return path.split(".").reduce((v, p) => (v !== undefined && v !== null ? v[isFinite(p) ? Number(p) : p] : v), obj);
}

export function setByPath(obj, path, value) {
  const parts = path.split(".");
  const clone = structuredClone(obj);
  let cur = clone;
  for (let i = 0; i < parts.length - 1; i++) {
    const p = isFinite(parts[i]) ? Number(parts[i]) : parts[i];
    cur = cur[p];
  }
  const last = isFinite(parts[parts.length - 1]) ? Number(parts[parts.length - 1]) : parts[parts.length - 1];
  cur[last] = value;
  return clone;
}
